import axios from 'axios';
import endpoints from '../api/endpoints';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/react';
import { getDefaultLanguage } from '@/utils/languageConfig';
import { enqueueSnackbar } from 'notistack';

// IB1-303 (épique #5428, F1.2/F5.1) : permet à un appel ponctuel de désactiver l'alert() global de
// l'intercepteur ci-dessous (ex: un panneau qui affiche déjà son propre message d'erreur dédié),
// sans toucher au comportement par défaut de tous les autres appels axios de l'app.
declare module 'axios' {
  export interface AxiosRequestConfig {
    skipGlobalErrorAlert?: boolean;
  }
}

axios.defaults.baseURL = endpoints.baseURL;

axios.interceptors.request.use(
  (config: any) => {
    const newConfig = config;
    if (!newConfig.headers['Content-Type']) newConfig.headers['Content-Type'] = 'application/json';
    newConfig.headers.Accept = '*/*';
    newConfig.headers['Accept-Language'] = localStorage.getItem('language') ?? getDefaultLanguage();
    newConfig.headers['locale'] = localStorage.getItem('language') ?? getDefaultLanguage();

    if (Cookies.get('accessToken')) {
      newConfig.headers.Authorization = `Bearer ${Cookies.get('accessToken')}`;
    } else if (Cookies.get('tmpToken')) {
      newConfig.headers.Authorization = `Bearer ${Cookies.get('tmpToken')}`;
    }
    return newConfig;
  },
  (error: any) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error.response) {
      const skipGlobalErrorAlert = error.config?.skipGlobalErrorAlert === true;

      const lang = localStorage.getItem('language') ?? getDefaultLanguage();
      const backendMsg = error.response.data?.message;
      const resolveMsg = (fallback: string): string =>
        (typeof backendMsg === 'object' ? (backendMsg[lang] ?? backendMsg['en']) : backendMsg) || fallback;

      switch (error.response.status) {
        case 500:
          if (!skipGlobalErrorAlert) enqueueSnackbar(resolveMsg('Internal Server Error'), { variant: 'notification', type: 'error' });
          break;
        case 402:
          enqueueSnackbar(resolveMsg('Payment Required'), { variant: 'notification', type: 'error' });
          break;
        case 404:
          if (!skipGlobalErrorAlert) enqueueSnackbar(resolveMsg('Resource not found'), { variant: 'notification', type: 'error' });
          process.env.REACT_APP_SENTRY_DSN !== 'disabled' &&
            Sentry.captureException(new Error('404 Not Found: Resource does not exist', error));
          break;
        case 403:
          // alert("Access Forbidden!");
          break;
        case 400:
          break;
        default:
          break;
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
